import { useState, useEffect, useCallback } from 'react';
import { api, MarketplaceArche } from '../../lib/api';

interface UseFeaturedArchesReturn {
  arches: MarketplaceArche[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useFeaturedArches(limit: number = 12): UseFeaturedArchesReturn {
  const [arches, setArches] = useState<MarketplaceArche[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFeatured = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await api.getFeaturedArches(limit);
      setArches(result.arches);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load featured arches');
      setArches([]);
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    fetchFeatured();
  }, [fetchFeatured]);

  return {
    arches,
    loading,
    error,
    refresh: fetchFeatured,
  };
}
